export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-primary-600 font-medium bg-primary-50 px-3 py-1 rounded-full">关于我们</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">关于我们</h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-2xl p-8 md:p-10">
            <div className="flex flex-col md:flex-row items-start gap-8">
              <div className="flex-shrink-0 w-20 h-20 flex items-center justify-center bg-primary-100 rounded-2xl">
                <i className="ri-shield-check-line text-3xl text-primary-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-heading font-bold text-foreground-950 mb-4">关于 911爆料网</h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  911爆料网成立于2020年，是国内最早一批专注于吃瓜黑料内容聚合与分发的独立平台。
                  我们以「真实、快速、全面」为核心原则，每日追踪娱乐圈、社会热点、网络红人、企业内幕等多领域的爆料事件，
                  致力于为吃瓜群众提供最及时、最劲爆的一手资讯。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                  平台拥有一支经验丰富的内容采编团队，通过多渠道信息交叉验证，确保每一条爆料都经得起推敲。
                  同时，我们严格保护爆料人隐私，建立了完善的匿名投稿机制，让每一个知情者都能安全发声。
                </p>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                  经过多年发展，911爆料网已成为国内吃瓜圈层最具影响力的平台之一，日均访问量超过百万，
                  是无数网友获取八卦资讯、交流讨论的首选入口。
                </p>

                <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
                  <div className="text-center p-4 bg-primary-50 rounded-xl">
                    <div className="text-2xl font-bold text-primary-600">5年+</div>
                    <div className="text-xs text-foreground-500 mt-1">行业深耕</div>
                  </div>
                  <div className="text-center p-4 bg-accent-50 rounded-xl">
                    <div className="text-2xl font-bold text-accent-600">百万+</div>
                    <div className="text-xs text-foreground-500 mt-1">日均访问量</div>
                  </div>
                  <div className="text-center p-4 bg-secondary-50 rounded-xl">
                    <div className="text-2xl font-bold text-secondary-600">10万+</div>
                    <div className="text-xs text-foreground-500 mt-1">累计爆料条数</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}